import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useCallback } from 'react'
import { RecordDetail } from '@user/features/GlobalSearch/FilterDrawer/typings'
import { saveCustomizedResultsSettings } from '@user/store/globalSearch'
import { CustomizedResultsSetting } from '@user/store/search/typings'
import { toast } from '@sales-center/components'

interface Props {
  onClose: () => void
  recordDetails: RecordDetail[]
}

export function useSaveCustomizedResultsSettings(props: Props) {
  const { recordDetails, onClose } = props
  const dispatch = useAppDispatch()

  return useCallback(async () => {
    const settings: CustomizedResultsSetting[] = recordDetails.map((record) => {
      return {
        id: record.id,
        isDraftLeadSelected: record.checkBoxes[0].checked,
        isLeadSelected: record.checkBoxes[1].checked,
        isOppSelected: record.checkBoxes[2].checked,
        settingName: record.title,
        isDraftLeadAvailable: record.checkBoxes[0].available,
      }
    })

    try {
      const result = await dispatch(saveCustomizedResultsSettings(settings))
      if (saveCustomizedResultsSettings.fulfilled.match(result)) {
        onClose()
      } else {
        const { payload } = result
        if (!!payload) {
          const { Message } = payload
          toast.error(Message)
        } else {
          toast.error('Unexpected error occurred.')
        }
      }
    } catch (e) {
      toast.error('Unexpected error occurred.')
    }
  }, [dispatch, recordDetails, onClose])
}
